import { render } from "./EventSvgTableEditIcon.vue?vue&type=template&id=32c71e88&scoped=true"
import script from "./EventSvgTableEditIcon.vue?vue&type=script&lang=js"
export * from "./EventSvgTableEditIcon.vue?vue&type=script&lang=js"

import "./EventSvgTableEditIcon.vue?vue&type=style&index=0&id=32c71e88&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c71e88"]])

export default __exports__